import { FunctionComponent, PropsWithChildren } from "react";
import styles from "./LabelTitle.module.css";

const LabelTitle: FunctionComponent<PropsWithChildren<{}>> = (props) => (
  <div>
    <span className={styles.title}>{props.children}</span>
  </div>
);

export default LabelTitle;
